/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Repeatedtooltip2Inputs */

const id_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah penawaran unik yang muncul beberapa kali di giveaway`)
};

const ms_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilangan tawaran unik yang muncul berkali-kali dalam pemberian`)
};

const da_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antal unikke tilbud der optræder flere gange i giveaways`)
};

const de_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Angebote, die mehrfach in Giveaways vorkommen`)
};

const en_us2_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of unique offers that appear multiple times in giveaways`)
};

const es_es2_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de ofertas únicas que aparecen múltiples veces en regalos`)
};

const es_mx2_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de ofertas únicas que aparecen múltiples veces en regalos`)
};

const fil_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilang ng mga natatanging offer na lumalabas nang maraming beses sa mga giveaway`)
};

const fr_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'offres uniques apparaissant plusieurs fois dans les gratuités`)
};

const it_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di offerte uniche che appaiono più volte nei giveaway`)
};

const hu_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ajándékokban többször megjelenő egyedi ajánlatok száma`)
};

const nl_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aantal unieke aanbiedingen dat meerdere keren in giveaways voorkomt`)
};

const no_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antall unike tilbud som vises flere ganger i giveaways`)
};

const pl_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liczba unikalnych ofert pojawiających się wielokrotnie w rozdaniach`)
};

const pt_br2_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of unique offers that appear multiple times in giveaways`)
};

const pt_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de ofertas únicas que aparecem múltiplas vezes em ofertas grátis`)
};

const ro_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numărul de oferte unice care apar de mai multe ori în ofertele gratuite`)
};

const fi_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niiden ainutlaatuisten tarjousten määrä, jotka esiintyvät useita kertoja ilmaisjaoissa`)
};

const sv_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antal unika erbjudanden som förekommer flera gånger i utlottningar`)
};

const vi_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng ưu đãi độc nhất xuất hiện nhiều lần trong các đợt tặng miễn phí`)
};

const tr_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava oyunlarda birden çok kez görünen benzersiz teklif sayısı`)
};

const cs_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet unikátních nabídek, které se objevily vícekrát ve výprodejích`)
};

const bg_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брой уникални оферти, които се появяват многократно в безплатни игри`)
};

const ru_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество уникальных предложений, появляющихся в раздачах несколько раз`)
};

const uk_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кількість унікальних пропозицій, які з'являються кілька разів у роздачах`)
};

const ar_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عدد العروض الفريدة التي تظهر عدة مرات في الهدايا`)
};

const hi_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कई बार दिखाई देने वाले ऑफ़र की संख्या`)
};

const th_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนข้อเสนอที่ไม่ซ้ำกันที่ปรากฏหลายครั้งในของแจกฟรี`)
};

const ja_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布に複数回登場するユニークなオファーの数`)
};

const zh_cn2_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of unique offers that appear multiple times in giveaways`)
};

const zh_hant1_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of unique offers that appear multiple times in giveaways`)
};

const ko_components_giveawaystats_repeatedtooltip2 = /** @type {(inputs: Components_Giveawaystats_Repeatedtooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of unique offers that appear multiple times in giveaways`)
};

/**
* | output |
* | --- |
* | "Number of unique offers that appear multiple times in giveaways" |
*
* @param {Components_Giveawaystats_Repeatedtooltip2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_repeatedtooltip2 = /** @type {((inputs?: Components_Giveawaystats_Repeatedtooltip2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Repeatedtooltip2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "ms") return ms_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "da") return da_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "de") return de_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "fil") return fil_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "fr") return fr_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "it") return it_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "hu") return hu_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "nl") return nl_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "no") return no_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "pl") return pl_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "pt") return pt_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "ro") return ro_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "fi") return fi_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "sv") return sv_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "vi") return vi_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "tr") return tr_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "cs") return cs_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "bg") return bg_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "ru") return ru_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "uk") return uk_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "ar") return ar_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "hi") return hi_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "th") return th_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "ja") return ja_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_repeatedtooltip2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_repeatedtooltip2(inputs)
	return ko_components_giveawaystats_repeatedtooltip2(inputs)
});
export { components_giveawaystats_repeatedtooltip2 as "components.giveawayStats.repeatedTooltip" }